import React, { useEffect, useState, useRef } from "react";
import { connect } from 'react-redux';
import { getChartItemAsync } from '../../BusinessMonitoringChartsAsyncThunk';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Filler, Title, Tooltip, Legend } from 'chart.js';
import { Line, Bar, Area } from 'react-chartjs-2';
ChartJS.register( CategoryScale, LinearScale, PointElement, LineElement, BarElement, Filler, Title, Tooltip, Legend );
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ChartItem = (props) => {
    const [chartType, setChartType] = useState('line'); //line|area|bar
    const [chartTime, setChartTime] = useState('hour'); //hour|day|week|month
    const [chartDataType, setChartDataType] = useState('average'); //average|peak
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const chartRef = useRef();

    let datasets = [];
    for (let index = 0; index < props.item.lineChartList.length; index++) {
        const color = (index == 0 ? '#8E8E8E' : '#6E2C6B');
        const colorWithOpacity = (index == 0 ? 'rgba(142, 142, 142, 0.2)' : 'var(--theme-primary, #9631ff)');

        let backgroundColor = '';
        switch (chartType) {
            case 'line': backgroundColor = 'transparent'; break;
            case 'area': backgroundColor = colorWithOpacity; break;
            case 'bar': backgroundColor = color; break;
        }

        const item = props.item.lineChartList[index];
        const data = {
            fill: (chartType == 'area' || chartType == 'bar'),
            label: item.lineDescription,
            data: item.series.map(x => x.lineValue),
            borderColor: color,
            backgroundColor: backgroundColor,
            pointBackgroundColor: color,
            pointBorderColor: color,
            pointRadius: 3,
            pointStyle: 'circle',
            borderWidth: 2,
            tension: 0.1,
        };
        datasets.push(data);
    }

    const data = {
        labels: props.item.lineChartList[0].series.map(x => x.lineDate),
        datasets: datasets
    }

    let options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 20,
                    font: { size: 12 }
                }
            },
            title: {
                display: true,
                text: props.item.graphTitle
            },
            subtitle: {
                display: false
            }
        },   
    }

    //console.info('datasets', datasets);

    return (
        <div className='chart-item'>

            <div className='chart-header'>
                <div className='titles-wrapper'>
                    <div> תצוגת גרף </div>
                    <div> קטע זמן מבוקש </div>
                    <div> אופן תצוגה </div>
                </div>
                <div className='buttons-wrapper'>
                    <div className='chart-types'>
                        <button onClick={()=> handleChartTypeClick('line')} className={chartType == 'line' ? 'active' : null}>קו</button>
                        <button onClick={()=> handleChartTypeClick('area')} className={chartType == 'area' ? 'active' : null}>שטח</button>
                        <button onClick={()=> handleChartTypeClick('bar')} className={chartType == 'bar' ? 'active' : null}>טור</button>                                        
                    </div>
              
                    <div className='chart-times'>
                        <button onClick={()=> handleChartTimeClick('hour')} className={chartTime == 'hour' ? 'active' : null}>שעה אחרונה</button>
                        <button onClick={()=> handleChartTimeClick('day')} className={chartTime == 'day' ? 'active' : null}>יממה אחרונה</button>
                        <button onClick={()=> handleChartTimeClick('week')} className={chartTime == 'week' ? 'active' : null}>שבוע אחרון</button>
                        <button onClick={()=> handleChartTimeClick('month')} className={chartTime == 'month' ? 'active' : null}>חודש אחרון</button>
                    </div>

                    <div className='chart-data-types'>
                        <button onClick={()=> handleChartDataTypeClick('peak')} className={chartDataType == 'peak' ? 'active' : null}>שיא</button>
                        <button onClick={()=> handleChartDataTypeClick('average')} className={chartDataType == 'average' ? 'active' : null}>ממוצע</button>                                        
                    </div>
                </div>                                
            </div>

            <div className='chart-wrapper'>
                <div className='menu-wrapper'>
                    <a className='hamburger-menu' href='#' onClick={(e)=> {e.preventDefault(); setIsMenuOpen(!isMenuOpen)}}></a> 
                    {
                        isMenuOpen && 
                        <div className='menu-items'>
                            <a href='#' onClick={(e)=> exportToPng(e)}>להורדת קובץ בפורמט PNG</a>
                            <a href='#' onClick={(e)=> exportToJpeg(e)}>להורדת קובץ בפורמט JPAG</a>
                            <a href='#' onClick={(e)=> exportToPdf(e)}>להורדת קובץ בפורמט PDF</a>
                            {/* <a href='#' onClick={(e)=> exportToSvg(e)}>להורדת קובץ בפורמט SVG</a> */}
                        </div>
                    }
                </div>  

                <div ref={chartRef}> 
                    {
                        chartType == 'bar' ? (
                            <Bar data={data} options={options} /> 
                        ) : (
                            <Line data={data} options={options} /> 
                        )
                    }                
                </div>                                       
            </div>
    
        </div>
    );

    function handleChartTypeClick(value) {
        setChartType(value);
    }

    function handleChartTimeClick(value) {
        setChartTime(value);    
        getChartItem(value,chartDataType);    
    }

    function handleChartDataTypeClick(value) {
        setChartDataType(value);
        getChartItem(chartTime, value);
    }    
    
    function getChartItem(chartTime, chartDataType) {
        //console.info('props.item', props.item);
        const data = {
            graphId: props.item?.graphId,            
            serviceCode: props.item?.serviceCode,
            resourceid: props.item?.resourceId,            
            hostName: '',    
            metric: props.item?.metricList,
            resolution: chartTime[0].toUpperCase(),
            startDate: '',
            endDate: '',
            graphDataType: chartDataType[0].toUpperCase(),
            nvId: props.item?.nvId,
            ifName: props.item?.ifName,
            resName: props.item?.resName
        }
        props.getChartItemAsync(data);
    }
    
    async function exportToPng() {
        const canvas = await html2canvas(chartRef.current);
        const imgData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'chart.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
    };

    async function exportToJpeg() {
        const canvas = await html2canvas(chartRef.current);
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'chart.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);         
    };

    async function exportToPdf(e) {
        e.preventDefault();
        const canvas = await html2canvas(chartRef.current);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('chart.pdf');    
    }

    async function exportToSvg() {
        const canvas = await html2canvas(chartRef.current);
        const imgData = canvas.toDataURL('image/png');
      
        const svgContent = `
          <svg xmlns="http://www.w3.org/2000/svg" width="800" height="600">
            <image href="${imgData}" width="800" height="600"/>
          </svg>
        `;
      
        const blob = new Blob([svgContent], { type: 'image/svg+xml' });
        const url = URL.createObjectURL(blob);
      
        const link = document.createElement('a');
        link.href = url;
        link.download = 'chart.svg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);              
    };

};

const mapStateToProps = (state) => {
    return { };
};
  
const mapDispatchToProps = { getChartItemAsync };
  
export default connect(mapStateToProps, mapDispatchToProps)(ChartItem);